import { render, staticRenderFns } from "./SaleOrderEventOrderStatusUpdate.vue?vue&type=template&id=2bf9290c&scoped=true"
import script from "./SaleOrderEventOrderStatusUpdate.vue?vue&type=script&lang=js"
export * from "./SaleOrderEventOrderStatusUpdate.vue?vue&type=script&lang=js"
import style0 from "./SaleOrderEventOrderStatusUpdate.vue?vue&type=style&index=0&id=2bf9290c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf9290c",
  null
  
)

export default component.exports